import { useField } from 'formik'
import React from 'react'
import { Box, Text } from '@mantine/core'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'

interface Props {
  placeholder?: string;
  name: string;
  label?: string;
}

export default function MyDateInput ({ label, ...props }: Partial<ReactDatePickerProps> & Props) {
  const [field, meta, helpers] = useField(props.name!)
  return (
    <Box sx={{ marginBottom: 12 }}>
      {label && (
        <Text
          component="label"
          size="sm"
          weight={500}
          sx={{ display: 'block', marginBottom: 6 }}
        >
          {label}
        </Text>
      )}
      <DatePicker
        {...field}
        {...props}
        selected={(field.value && new Date(field.value)) || null}
        onChange={(value) => helpers.setValue(value)}
        className="react-datepicker-wrapper"
      />
      {meta.touched && meta.error && (
        <Text size="sm" color="red" mt={4}>
          {meta.error}
        </Text>
      )}
    </Box>
  )
}
